import * as React from 'react';

import { SimpleTreeView } from '@mui/x-tree-view';
import { Box, Skeleton } from '@mui/material';

import { WSConfigTreeData } from '../../types/WSConfigData';

import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { FolderLabel } from '../../subs/FolderLabel';
import { StyledTreeItem } from '../../subs/StyledTreeItem';

const WSConfigProdItem = ({ treeNode, treeType }:
    {
        treeNode: WSConfigTreeData, treeType: string
    }) => {

    return <>
        {treeNode.key.workshopProductId && (<StyledTreeItem itemId={treeType + '-' + treeNode.key.workshopProductId.toString()}
            label={<FolderLabel labelText={`${treeNode.treeNodeName ?? ''}`}
                alternateIcon={treeNode.alternateIcon ? 0 : 1} 
                labelVariant='small' color={treeNode.testCasesSum === treeNode.testCasesMarked ? 'success' : 'info'}
                passed={treeNode.testCasesMarked} info={treeNode.testCasesSum - treeNode.testCasesMarked}
            />}
        />)}
    </>
}

const WSConfigTreeItem = ({ treeNode, wsConfigTreeData }:
    {
        treeNode: WSConfigTreeData, wsConfigTreeData: WSConfigTreeData[]
    }) => {
    const providerNode = wsConfigTreeData.find(td => td.key.wsTreeEntryType === 1 && td.key.testCombinationId === treeNode.key.testCombinationId && td.key.workshopProductId === 0);
    const consumerNode = wsConfigTreeData.find(td => td.key.wsTreeEntryType === 2 && td.key.testCombinationId === treeNode.key.testCombinationId && td.key.workshopProductId === 0);

    return <>
        {
            <StyledTreeItem itemId={treeNode.key.testCombinationId.toString()} label={<FolderLabel labelText={treeNode.treeNodeName ?? 'error'} labelVariant='large'
                color={treeNode.testCasesSum === treeNode.testCasesMarked ? 'success' : 'info'}
                passed={treeNode.testCasesMarked} info={treeNode.testCasesSum - treeNode.testCasesMarked}
            />}>
                {consumerNode !== undefined &&
                    <StyledTreeItem itemId={consumerNode.key.testCombinationId.toString() + '-2'} label={<FolderLabel labelText={consumerNode.treeNodeName ?? 'error'} labelVariant='large'
                        color={consumerNode.testCasesSum === consumerNode.testCasesMarked ? 'success' : 'info'}
                        passed={consumerNode.testCasesMarked} info={consumerNode.testCasesSum - consumerNode.testCasesMarked}
                    />}>
                        {wsConfigTreeData.map(wstn =>
                            wstn.key.testCombinationId === consumerNode.key.testCombinationId
                            && wstn.key.wsTreeEntryType === consumerNode.key.wsTreeEntryType
                            && wstn.key.workshopProductId !== 0 &&
                            <WSConfigProdItem treeType={consumerNode.key.testCombinationId.toString() + '-2'}
                                treeNode={wstn}
                            />
                        )}
                    </StyledTreeItem>}
                {providerNode !== undefined &&
                    <StyledTreeItem itemId={providerNode.key.testCombinationId.toString() + '-1'} label={<FolderLabel labelText={providerNode.treeNodeName ?? 'error'} labelVariant='large'
                        color={providerNode.testCasesSum === providerNode.testCasesMarked ? 'success' : 'info'}
                        passed={providerNode.testCasesMarked} info={providerNode.testCasesSum - providerNode.testCasesMarked}
                    />}>
                        {wsConfigTreeData.map(wstn =>
                            wstn.key.testCombinationId === providerNode.key.testCombinationId
                            && wstn.key.wsTreeEntryType === providerNode.key.wsTreeEntryType
                            && wstn.key.workshopProductId !== 0 &&
                            <WSConfigProdItem treeType={providerNode.key.testCombinationId.toString() + '-1'}
                                treeNode={wstn}
                            />
                        )}
                    </StyledTreeItem>}
            </StyledTreeItem>
        }
    </>
}

export const WSConfigProdTree = ({ wsConfigTreeData, getSelectedNode, nodeSelectHandler }:
    {
        wsConfigTreeData: WSConfigTreeData[],
        getSelectedNode: () => string,
        nodeSelectHandler: (event: React.SyntheticEvent, itemId: string) => void
    }) => {

    return <Box minWidth={'35%'}>
        {wsConfigTreeData ? (
            <SimpleTreeView slots={{ collapseIcon: RemoveIcon, expandIcon: AddIcon }} selectedItems={getSelectedNode()} onItemSelectionToggle={nodeSelectHandler}>
                {wsConfigTreeData.map(combo =>
                    combo.key.wsTreeEntryType === 0 &&
                    <WSConfigTreeItem treeNode={combo}
                        wsConfigTreeData={wsConfigTreeData.filter(td => td.key.wsTreeEntryType !== 0 && td.key.testCombinationId === combo.key.testCombinationId)}
                    />
                )}
            </SimpleTreeView>
        ) : (
            <Skeleton variant="rectangular" width={'90%'} height={118} />
        )}
    </Box>
}